import { effects } from 'redux-saga'

import callWithHmac from '../../effects/callWithHmac'
import timeout from '../../../../util/timeout'

import { changedPassword, errorPassword, hideChangePassword } from '../../../modules/service/changePassword'
import validate from './validate'

export default function* change(invocation) {
  const state = yield effects.select()
  const passwordState = state.service.get('changePassword')
  const password = passwordState.get('password')

  const result = yield effects.call(validate, password.get('first'), password.get('second'))
  if (!result) {
    return
  }

  try {
    yield effects.call(
      callWithHmac,
      invocation.changeServicePassword,
      passwordState.get('serviceId'),
      password.get('first'),
    )

    yield effects.put.resolve(changedPassword())
    yield effects.call(timeout, 750)
    yield effects.put.resolve(hideChangePassword())
  } catch (e) {
    if (!e.json || !Object.hasOwnProperty.call(e.json, 'violations')) {
      throw e
    }

    yield effects.put.resolve(errorPassword(e.json.violations.map(v => v.message)))
  }
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/sagas/service/changePassword/change.js